import request from '../../utils/request';

export const roleService = {
    //角色列表数据查询
    getRoleData: (data) => {
        return request({
            url: '/role/list',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    //角色删除
    deleteRole: (data) => {
        return request({
            url: '/role/deleteRole',
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    //角色信息修改
    saveOrUpdateRole: (data,method) => {
        let callUrl = "/role/edit"
        if('add' === method){
            callUrl = "/role/new"
        }
        return request({
            url: callUrl,
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
    //权限树
    getFunctionTreeData: (roleId) => {
        return request({
            url: '/role/function/'+roleId,
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: {}
        })
    },
    //角色权限保存
    saveFunctionTreeData: (roleId,data) => {
        return request({
            url: '/role/saveFunction/'+roleId,
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            data: data
        })
    },
}